// transitLoginViewStatus.js
'use strict';
import addModal from '../action/addModal.js';
import removeModals from '../action/removeModals.js';
import { login as loginModal } from '../resource/modalId.js';

/**
 * Transit login view status
 * @kind action
 * @param {string} {from} - Origin login view key.
 * @param {string} {to} - Target login view key.
 * @return {Promise} Action promise.
 */
const transitLoginViewStatus =
  ({ from, to }) =>
  async dispatch => {
    if ('accountRegister' === from && 'methodSelect' === to) {
      dispatch(
        addModal({
          id: loginModal.METHOD_SELECT,
          isHigherThanAll: true,
          transitionStatus: 'coming',
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.ACCOUNT_REGISTER],
          transitionStatus: 'leaving',
        })
      );
    } else if ('methodSelect' === from && 'accountRegister' === to) {
      dispatch(
        addModal({
          id: loginModal.ACCOUNT_REGISTER,
          isHigherThanAll: true,
          transitionStatus: 'backing',
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.METHOD_SELECT],
          transitionStatus: 'reversing',
        })
      );
    } else if ('accountRegister' === from && 'email' === to) {
      dispatch(
        addModal({
          id: loginModal.EMAIL,
          isHigherThanAll: true,
          transitionStatus: 'coming',
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.ACCOUNT_REGISTER],
          transitionStatus: 'leaving',
        })
      );
    } else if ('email' === from && 'accountRegister' === to) {
      dispatch(
        addModal({
          id: loginModal.ACCOUNT_REGISTER,
          isHigherThanAll: true,
          transitionStatus: 'backing',
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.EMAIL],
          transitionStatus: 'reversing',
        })
      );
    } else if ('accountRegister' === from && 'phone' === to) {
      dispatch(
        addModal({
          id: loginModal.PHONE,
          isHigherThanAll: true,
          transitionStatus: 'coming',
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.ACCOUNT_REGISTER],
          transitionStatus: 'leaving',
        })
      );
    } else if ('phone' === from && 'accountRegister' === to) {
      dispatch(
        addModal({
          id: loginModal.ACCOUNT_REGISTER,
          isHigherThanAll: true,
          transitionStatus: 'backing',
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.PHONE],
          transitionStatus: 'reversing',
        })
      );
    } else if ('methodSelect' === from && 'forgotPasswordEmail' === to) {
      dispatch(
        addModal({
          id: loginModal.FORGOT_PASSWORD_EMAIL,
          isHigherThanAll: true,
          transitionStatus: 'coming',
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.METHOD_SELECT],
          transitionStatus: 'leaving',
        })
      );
    } else if ('forgotPasswordEmail' === from && 'methodSelect' === to) {
      dispatch(
        addModal({
          id: loginModal.METHOD_SELECT,
          isHigherThanAll: true,
          transitionStatus: 'backing',
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.FORGOT_PASSWORD_EMAIL],
          transitionStatus: 'reversing',
        })
      );
    } else if ('usernamePassword' === from && 'forgotPasswordEmail' === to) {
      dispatch(
        addModal({
          id: loginModal.FORGOT_PASSWORD_EMAIL,
          isHigherThanAll: true,
          transitionStatus: 'coming',
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.PASSWORD],
          transitionStatus: 'leaving',
        })
      );
    } else if ('forgotPasswordEmail' === from && 'usernamePassword' === to) {
      dispatch(
        addModal({
          id: loginModal.PASSWORD,
          isHigherThanAll: true,
          transitionStatus: 'backing',
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.FORGOT_PASSWORD_EMAIL],
          transitionStatus: 'reversing',
        })
      );
    } else if ('forgotPasswordPhone' === from && 'methodSelect' === to) {
      dispatch(
        addModal({
          id: loginModal.METHOD_SELECT,
          isHigherThanAll: true,
          transitionStatus: 'backing',
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.FORGOT_PASSWORD_PHONE],
          transitionStatus: 'reversing',
        })
      );
    } else if ('forgotPasswordEmail' === from && 'forgotPasswordPhone' === to) {
      dispatch(
        addModal({
          id: loginModal.FORGOT_PASSWORD_PHONE,
          isHigherThanAll: true,
          transitionStatus: 'coming',
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.FORGOT_PASSWORD_EMAIL],
          transitionStatus: 'leaving',
        })
      );
    } else if ('forgotPasswordPhone' === from && 'forgotPasswordEmail' === to) {
      dispatch(
        addModal({
          id: loginModal.FORGOT_PASSWORD_EMAIL,
          isHigherThanAll: true,
          transitionStatus: 'coming',
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.FORGOT_PASSWORD_PHONE],
          transitionStatus: 'leaving',
        })
      );
    } else if (
      'forgotPasswordPhone' === from &&
      'forgotPasswordPhoneVerify' === to
    ) {
      dispatch(
        addModal({
          id: loginModal.FORGOT_PASSWORD_PHONE_VERIFY,
          isHigherThanAll: true,
          transitionStatus: 'coming',
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.FORGOT_PASSWORD_PHONE],
          transitionStatus: 'leaving',
        })
      );
    } else if (
      'forgotPasswordPhoneVerify' === from &&
      'forgotPasswordPhone' === to
    ) {
      dispatch(
        addModal({
          id: loginModal.FORGOT_PASSWORD_PHONE,
          isHigherThanAll: true,
          transitionStatus: 'backing',
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.FORGOT_PASSWORD_PHONE_VERIFY],
          transitionStatus: 'reversing',
        })
      );
    } else if (
      'forgotPasswordEmail' === from &&
      'forgotPasswordEmailVerify' === to
    ) {
      dispatch(
        addModal({
          id: loginModal.FORGOT_PASSWORD_EMAIL_VERIFY,
          isHigherThanAll: true,
          transitionStatus: 'coming',
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.FORGOT_PASSWORD_EMAIL],
          transitionStatus: 'leaving',
        })
      );
    } else if (
      'forgotPasswordEmailVerify' === from &&
      'forgotPasswordEmail' === to
    ) {
      dispatch(
        addModal({
          id: loginModal.FORGOT_PASSWORD_EMAIL,
          isHigherThanAll: true,
          transitionStatus: 'backing',
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.FORGOT_PASSWORD_EMAIL_VERIFY],
          transitionStatus: 'reversing',
        })
      );
    } else if ('methodSelect' === from && 'phone' === to) {
      dispatch(
        addModal({
          id: loginModal.PHONE,
          isHigherThanAll: true,
          transitionStatus: 'coming',
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.METHOD_SELECT],
          transitionStatus: 'leaving',
        })
      );
    } else if ('methodSelect' === from && 'registerStartMethodSelect' === to) {
      dispatch(
        addModal({
          id: loginModal.REGISTER_START,
          isHigherThanAll: true,
          transitionStatus: 'coming',
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.METHOD_SELECT],
          transitionStatus: 'leaving',
        })
      );
    } else if ('registerStartMethodSelect' === from && 'methodSelect' === to) {
      dispatch(
        addModal({
          id: loginModal.METHOD_SELECT,
          transitionStatus: 'backing',
          isHigherThanAll: true,
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.REGISTER_START],
          transitionStatus: 'reversing',
        })
      );
    } else if ('registerStartMethodSelect' === from && 'phone' === to) {
      dispatch(
        addModal({
          id: loginModal.PHONE,
          transitionStatus: 'coming',
          isHigherThanAll: true,
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.REGISTER_START],
          transitionStatus: 'leaving',
        })
      );
    } else if ('phone' === from && 'methodSelect' === to) {
      dispatch(
        addModal({
          id: loginModal.METHOD_SELECT,
          transitionStatus: 'backing',
          isHigherThanAll: true,
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.PHONE],
          transitionStatus: 'reversing',
        })
      );
    } else if ('phone' === from && 'registerStartMethodSelect' === to) {
      dispatch(
        addModal({
          id: loginModal.REGISTER_START,
          transitionStatus: 'backing',
          isHigherThanAll: true,
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.PHONE],
          transitionStatus: 'reversing',
        })
      );
    } else if ('phone' === from && 'country' === to) {
      return dispatch(
        addModal({
          id: loginModal.PHONE_COUNTRY_SELECT,
          isHigherThanAll: true,
          transitionStatus: 'coming',
        })
      );
    } else if ('country' === from && 'phone' === to) {
      return dispatch(
        removeModals({
          ids: [loginModal.PHONE_COUNTRY_SELECT],
          transitionStatus: 'reversing',
        })
      );
    } else if ('methodSelect' === from && 'usernamePassword' === to) {
      dispatch(
        addModal({
          id: loginModal.PASSWORD,
          transitionStatus: 'coming',
          isHigherThanAll: true,
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.METHOD_SELECT],
          transitionStatus: 'leaving',
        })
      );
    } else if ('usernamePassword' === from && 'methodSelect' === to) {
      dispatch(
        addModal({
          id: loginModal.METHOD_SELECT,
          transitionStatus: 'backing',
          isHigherThanAll: true,
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.PASSWORD],
          transitionStatus: 'reversing',
        })
      );
    } else if ('methodSelect' === from && 'phoneVerify' === to) {
      dispatch(
        addModal({
          id: loginModal.PHONE_VERIFY,
          isHigherThanAll: true,
          transitionStatus: 'coming',
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.METHOD_SELECT],
          transitionStatus: 'leaving',
        })
      );
    } else if ('phoneVerify' === from && 'methodSelect' === to) {
      dispatch(
        addModal({
          id: loginModal.METHOD_SELECT,
          transitionStatus: 'backing',
          isHigherThanAll: true,
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.PHONE_VERIFY],
          transitionStatus: 'reversing',
        })
      );
    } else if ('phone' === from && 'phoneVerify' === to) {
      dispatch(
        addModal({
          id: loginModal.PHONE_VERIFY,
          isHigherThanAll: true,
          transitionStatus: 'coming',
        })
      );
      return dispatch(
        removeModals({ ids: [loginModal.PHONE], transitionStatus: 'leaving' })
      );
    } else if ('phoneVerify' === from && 'phone' === to) {
      dispatch(
        addModal({
          id: loginModal.PHONE,
          transitionStatus: 'backing',
          isHigherThanAll: true,
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.PHONE_VERIFY],
          transitionStatus: 'reversing',
        })
      );
    } else if ('phoneReward' === from && 'phoneVerify' === to) {
      dispatch(
        addModal({
          id: loginModal.PHONE_VERIFY,
          isHigherThanAll: true,
          transitionStatus: 'coming',
        })
      );
      return dispatch(
        removeModals({
          ids: ['PhoneVerifyRewardModal'],
          transitionStatus: 'leaving',
        })
      );
    } else if ('phoneVerify' === from && 'phoneReward' === to) {
      dispatch(
        addModal({
          id: 'PhoneVerifyRewardModal',
          transitionStatus: 'backing',
          isHigherThanAll: true,
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.PHONE_VERIFY],
          transitionStatus: 'reversing',
        })
      );
    } else if ('phone' === from && 'ageVerificationOptions' === to) {
      dispatch(
        addModal({
          id: loginModal.AGE_VERIFICATION_OPTIONS,
          transitionStatus: 'coming',
          isHigherThanAll: true,
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.PHONE],
          transitionStatus: 'leaving',
        })
      );
    } else if ('ageVerificationOptions' === from && 'phone' === to) {
      dispatch(
        addModal({
          id: loginModal.PHONE,
          transitionStatus: 'backing',
          isHigherThanAll: true,
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.AGE_VERIFICATION_OPTIONS],
          transitionStatus: 'reversing',
        })
      );
    } else if ('methodSelect' === from && 'email' === to) {
      dispatch(
        addModal({
          id: loginModal.EMAIL,
          isHigherThanAll: true,
          transitionStatus: 'coming',
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.METHOD_SELECT],
          transitionStatus: 'leaving',
        })
      );
    } else if ('registerStartMethodSelect' === from && 'email' === to) {
      dispatch(
        addModal({
          id: loginModal.EMAIL,
          transitionStatus: 'coming',
          isHigherThanAll: true,
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.REGISTER_START],
          transitionStatus: 'leaving',
        })
      );
    } else if ('email' === from && 'methodSelect' === to) {
      dispatch(
        addModal({
          id: loginModal.METHOD_SELECT,
          transitionStatus: 'backing',
          isHigherThanAll: true,
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.EMAIL],
          transitionStatus: 'reversing',
        })
      );
    } else if ('email' === from && 'registerStartMethodSelect' === to) {
      dispatch(
        addModal({
          id: loginModal.REGISTER_START,
          transitionStatus: 'backing',
          isHigherThanAll: true,
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.EMAIL],
          transitionStatus: 'reversing',
        })
      );
    } else if ('methodSelect' === from && 'emailVerify' === to) {
      dispatch(
        addModal({
          id: loginModal.EMAIL_VERIFY,
          isHigherThanAll: true,
          transitionStatus: 'coming',
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.METHOD_SELECT],
          transitionStatus: 'leaving',
        })
      );
    } else if ('emailVerify' === from && 'methodSelect' === to) {
      dispatch(
        addModal({
          id: loginModal.METHOD_SELECT,
          transitionStatus: 'backing',
          isHigherThanAll: true,
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.EMAIL_VERIFY],
          transitionStatus: 'reversing',
        })
      );
    } else if ('email' === from && 'emailVerify' === to) {
      dispatch(
        addModal({
          id: loginModal.EMAIL_VERIFY,
          isHigherThanAll: true,
          transitionStatus: 'coming',
        })
      );
      return dispatch(
        removeModals({ ids: [loginModal.EMAIL], transitionStatus: 'leaving' })
      );
    } else if ('emailVerify' === from && 'email' === to) {
      dispatch(
        addModal({
          id: loginModal.EMAIL,
          transitionStatus: 'backing',
          isHigherThanAll: true,
        })
      );
      return dispatch(
        removeModals({
          ids: [loginModal.EMAIL_VERIFY],
          transitionStatus: 'reversing',
        })
      );
    } else if ('null' === from && 'emailVerify' === to) {
      return dispatch(
        addModal({
          id: loginModal.EMAIL_VERIFY,
          isHigherThanAll: true,
          transitionStatus: 'opening',
        })
      );
    } else if ('qrCode' === to) {
      return dispatch(
        addModal({
          id: loginModal.QR_CODE,
          transitionStatus: 'coming',
          isHigherThanAll: true,
        })
      );
    }
    return dispatch({ type: '' });
  };

export default transitLoginViewStatus;
